export default customElements.define('w-pip', class Pip extends wealthify.CustomElementBaseClass {

    constructor() {
        const config = {
            styleSelector: 'c-pip',
            templateHTML: `
                <button class="c-pip__container" data-root>
                    <div class="c-pip__main" aria-hidden="true">
                </button>`
        };

        super(config);

        this.onConnectedCallback = () => {
            this.classList.add(this.styleSelector);
        };
    }

    static get validStates () {
        return ['complete', 'selected'];
    }

    static get observedProps () {
        return [
            new wealthify.Prop('label', {required: true}),
            new wealthify.Prop('onclickprop', {type: wealthify.propTypes.Function()}),
            new wealthify.Prop('state', {
                type: wealthify.propTypes.ArrayItem(this.validStates),
                default: 'selected'
            }),
            wealthify.props.Disabled()
        ];
    }

    get propCallbacks() {
        return {
            label: (value) => this.dom.root.setAttribute('aria-label', value),
            onclickprop: (value) => this.dom.root.onclick = value,
            state: (value) => {
                this.constructor.validStates.forEach((state) => this.dom.root.classList.remove(`${this.styleSelector}--state-${state}`));
                
                this.dom.root.classList.add(`${this.styleSelector}__container--state-${value}`);
            }
        };
    }
});